module.exports = __webpack_public_path__ + "img/banner1.4b08f819.png";